export default {
  isTransactionSuccess: (state) => state.isSucceeded,
  getErrors: (state) => () => {
    return {
      errorMessage: state.errorMessage,
      validationErrors: state.validationErrors,
    };
  },

  getAllUserFields: (state) => state.userFieldsResponse.data,
};
